import { ConfigService } from '../../'

export class MapConfig {
	public fit				= [ [ 35, -87 ], [ 38, -84 ] ]
	public grayScale	= 0
	public zoom				= !(
    navigator.userAgent.indexOf('iPhone')   !== -1 ||
    navigator.userAgent.indexOf('iPad')     !== -1 ||
    navigator.userAgent.indexOf('Android')  !== -1
  )

	constructor(private config: ConfigService) {}

	update(config: any): MapConfig {
		if (typeof config.map === 'object') {
			this.fit				= typeof config.map.fit === 'object' ? config.map.fit : this.fit;
      this.grayScale	= (typeof config.map.grayScale === 'boolean' ?
        config.map.grayScale : false) ? -100 : 0;
		}

		return this;
	}
}



// WEBPACK FOOTER //
// ./src/app/electraLib/model/config/mapConfig.ts